export default __webpack_public_path__ + "static/media/google.77a59cd8.svg";